export const PROMOTION_LIST = [
  {
    index: '01',
    desc: 'Miễn Phí chuyển tiền Online trong và ngoài hệ thống.',
  },
  {
    index: '02',
    desc: 'Miễn Phí duy trì tài khoản.',
  },
  {
    index: '03',
    desc: 'Miễn Phí SMS Banking áp dụng cho 02 số điện thoại/tài khoản.',
  },
  {
    index: '04',
    desc: 'Miễn Phí đăng ký, phí thường niên Internet Banking.',
  },
  {
    index: '05',
    desc: 'Miễn phí chi lương.',
  },
  {
    index: '06',
    desc: 'Tặng bảo hiểm thất nghiệp- Bảo hiểm trợ cấp việc làm cho nhân viên được chi lương qua VPBank.',
  },
  {
    index: '07',
    desc: 'Miễn phí chuyển tiền quốc tế online.',
  },
  {
    index: '08',
    desc: 'Ưu đãi tỷ giá FX lên đến 150 điểm.',
  },
  {
    index: '09',
    desc: 'Đặc quyền phòng chờ VIP tại sân bay.',
  },
]